module.exports = __WEBPACK_EXTERNAL_MODULE_31__;


//////////////////
// WEBPACK FOOTER
// external "@angular/http"
// module id = 31
// module chunks = 0 1